import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import MultipleProgressChart, { MultipleProgressChartData } from '../charts/MultipleProgressChart';
import { DashboardFiltersContext } from '../filters/DashboardFiltersContext';
import { GetSalesInsightsGroupedRequest, SalesInsightsGroupedResponse, useSalesInsightsGrouped } from '../../../../api/indicators';
import { dateRange, formatDateTimeParam } from '../../../../helpers/dateUtils';
import { DashboardContext } from '../../DashboardContext';

const TransactionsByLocation = () => {
    const { t } = useTranslation();
    const { filters, dateRangeConfig } = useContext(DashboardFiltersContext);
    const [multipleChartData, setMultipleChartData] = useState<MultipleProgressChartData[]>([]);
    const [transactionByLocationSum, setTransactionByLocationSum] = useState(0);
    const { refreshDate, companyConfig } = useContext(DashboardContext);

    const [params, setParams] = useState<GetSalesInsightsGroupedRequest>({
        groupBy: 'location',
        fields: 'transactionVolume',
        startDateTime: formatDateTimeParam(filters.periodFrom ? filters.periodFrom : dateRange("today", undefined, undefined, undefined, dateRangeConfig).startDate),
        endDateTime: formatDateTimeParam(filters.periodTo ? filters.periodTo : dateRange("today", undefined, undefined, undefined, dateRangeConfig).endDate),
        locations: filters?.locations?.join(',') ? filters?.locations?.join(',') : companyConfig?.locations?.map(location => location.id).join(','),
        locationArea: filters?.locationArea?.id
    });

    const {
        data: salesInsightsGrouped,
        isLoading,
        isError,
        refetch: fetchTransactionByLocation
    } = useSalesInsightsGrouped<SalesInsightsGroupedResponse>(params, 'transactions-insights-grouped-by-location');

    useEffect(() => {
        if (salesInsightsGrouped?.salesInsightsGrouped){
            let sum = 0;
            setMultipleChartData(
                salesInsightsGrouped.salesInsightsGrouped.map(
                    // eslint-disable-next-line arrow-body-style
                    (salesInsightsGroupedObject) => {
                        sum += salesInsightsGroupedObject.salesInsights.transactionVolume || 0;
                        return {
                            key: salesInsightsGroupedObject.key,
                            value: salesInsightsGroupedObject.salesInsights.transactionVolume ||0
                        }
                    })
                )
                setTransactionByLocationSum(sum);
        }
    }, [salesInsightsGrouped]);

    useEffect(() => {
        setParams({
            ...params,
            startDateTime: formatDateTimeParam(filters.periodFrom ? filters.periodFrom : dateRange("today", undefined, undefined, undefined, dateRangeConfig).startDate),
            endDateTime: formatDateTimeParam(filters.periodTo ? filters.periodTo : dateRange("today", undefined, undefined, undefined, dateRangeConfig).endDate),
            locations: filters?.locations?.join(',') ? filters?.locations?.join(',') : companyConfig?.locations?.map(location => location.id).join(','),
            locationArea: filters?.locationArea?.id,
        })
    }, [filters]);

    useEffect(() => {fetchTransactionByLocation();}, [params]);

    useEffect(() => {
        if (refreshDate != null) {
            fetchTransactionByLocation();
        }
    }, [refreshDate]);

    return (
        <Box >
            <MultipleProgressChart
                isError={isError}
                title={t('screens.dashboarding.charts.transactionsByLocation')}
                description={t('screens.dashboarding.charts.volume')}
                sum={transactionByLocationSum}
                showCurrency={false}
                textLink={t("screens.dashboarding.charts.transactionsOverview")} 
                linkChart={`${process.env.REACT_APP_OAUTH_CALLBACK_URL}transactions`}            
                isLoading={isLoading}
                data={multipleChartData}
            />
        </Box>
    )
}


export default TransactionsByLocation;
